<script lang="ts">import { t, Verbiage } from "@infinitro/content";
import { getIcon } from "../data/icons";
const LikeIconComment = getIcon("LikeIconComment");
</script>

{#if typeof LikeIconComment === 'string'}
	<img src={LikeIconComment} alt={$t(Verbiage.icon_alt, 'alts')} />
{:else if typeof LikeIconComment === 'function'}
	<svelte:component this={LikeIconComment} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
